import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbDateParserFormatter, NgbDatepickerModule, NgbDropdownModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { CustomDateParserFormatter } from '../../../Util/DateFormat/date-format.service';
import { CommonService } from '../../../Model/Common/common.service';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';
import { ComboService } from '../../../Model/Combo/combo.service';
import { MusterAttendanceService } from '../../../Model/MusterAttendance/muster-attendance.service';
import { AadhaarKYCComponent } from '../../AadhaarKYC/aadhaar-kyc/aadhaar-kyc.component';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { SessionService } from '../../../Util/Session/session.service';
import { UtilityService } from '../../../Model/utility/utility.service';
import moment from 'moment';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';
import { EmployeeRegistrationService } from '../../../Model/EmployeeRegistration/employee-registration.service';
import { ActivatedRoute, Router, } from '@angular/router';
import { AlertWarningComponent } from '../../../Component/Alert/alert-warning/alert-warning.component';
import { AlertSuccessComponent } from '../../../Component/Alert/alert-success/alert-success.component';
import { join } from 'path';

@Component({
  selector: 'app-sub-contractor-form',
  standalone: true,
  imports: [CommonModule, FormsModule, NgbDatepickerModule, NgSelectModule, NgbDropdownModule, LoaderComponent],
  providers: [
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
  ],
  templateUrl: './sub-contractor-form.component.html',
  styleUrl: './sub-contractor-form.component.scss'
})
export class SubContractorFormComponent {
  isDisabled: boolean = false;
  MinDate = {
    day: 1,
    month: 1,
    year: 1800
  };
  Branchs = [] as any;
  Clients = [] as any;
  Sites = [] as any;
  Vendors = [] as any;
  Designations = [] as any;
  Dutys = [] as any;
  Shifts = [] as any;
  Genders = [] as any;
  ServiceTypes = [] as any;
  PostJoiningDate = null as any;

  Detail = {
    SelectType: 'i',
    EmpMasterId: 0,
    NameAsPerAadhar: null as any,
    FirstName: null as any,
    MiddleName: null as any,
    LastName: null as any,
    Photo: null,
    PhotoURL: null as any,
    GenderId: null,
    BranchID: null,
    BranchName: null as any,
    ClientId: null,
    ClientGroupName: null as any,
    SiteId: null,
    SiteName: null as any,
    SiteCode: null as any,
    VendorId: null,
    VendorCode: null as any,
    VendorName: null as any,
    DesignationId: null,
    DesignationName: null as any,
    DutyId: null,
    DutyName: null as any,
    ShiftId: null,
    ShiftCode: null as any,
    ShiftTitle: null as any,
    BirthDateObj: null as any,
    BirthDate: null as any,
    ServiceTypeId: null,
    ServiceType: null as any,
    AADHARVerificationID: null,
    AadharNo: null,
    AadharNoKyc: null,
    AadharBirthDate: null as any,
    AadharGenderID: null as any,
    AadhaarGender: null as any,
    AadharImage: null,
    AadhaarPhotoURL: null as any,
    AadharAddress1: null,
    AadharAddress2: null,
    AadharAttachment: null,
    AadhaarAttachmentURL: null as any,
    AadhaarVerificationStatus: 'Not Verified',
    IsWebEntry: false,
    joiningDate: null as any,
    TodayDate: null as any,
  }

  VerificationStatus = {
    AADHAARCardVerificationEnabled: false,
    CompulsoryAADHAARKYCVerification: false,
  };

  user = [] as any;

  constructor(
    protected common: CommonService,
    protected sanitizer: DomSanitizer,
    private combo: ComboService,
    private musterAttendance: MusterAttendanceService,
    private modalService: NgbModal,
    private session: SessionService,
    private toast: ToastService,
    private utility: UtilityService,
    protected dateFormat: CustomDateParserFormatter,
    private employeeRegistration: EmployeeRegistrationService,
    private route: ActivatedRoute,
    private router: Router,
  ) {
    this.route.params.subscribe(params => this.Detail.EmpMasterId = parseInt(params['id']));
    this.user = this.session.GetUserDetails();
    this.common.getPageRights();
  }

  ngOnInit(): void {
    this.GetAadharPanBankCompulsory();
    this.GetInit();
  }


  async GetInit() {
    await this.common.CompanyParameter();

    this.SelectDate('RegistrationDate');
    this.SelectDate('PreJoiningDate');

    if (this.Detail.EmpMasterId > 0) {
      this.ESS_EmployeeSubcontracterSelect();
    } else {
      this.ComboLoad('Branch');
      this.ESS_FillComboOAS('Vendor');
      this.ESS_FillComboOAS('ServiceType');
    }
    this.ComboLoad('Gender');
  }

  Validate(form: any) {
    if (form.valid) {
      if ((this.Detail.EmpMasterId == 0 && this.common.PageRight.IsAdd) || (this.Detail.EmpMasterId > 0 && this.common.PageRight.IsEdit)) {
        this.Detail.joiningDate = moment(this.dateFormat.format(this.Detail.BirthDateObj));
        this.Detail.joiningDate = moment(this.Detail.joiningDate.add({ year: 18 }));
        this.Detail.joiningDate = this.dateFormat.format(this.dateFormat.parse(this.Detail.joiningDate.format("DD MMM YYYY")));

        const difDay = this.common.CompanyParameterValue.RestrictFutureDateEntry ? this.getDayDifference(this.Detail.joiningDate, this.PostJoiningDate) : 1;
        if (difDay > 0) {
          this.ESS_EmpSubContractor_InsertUpdate();
        } else {
          this.toast.show({ message: "Date of joing not allow after " + this.PostJoiningDate, type: toastTypeEnum.warning });
        }
      }
    }
    else {
      form.submitted = true;
    }
  }

  upload(event: any, Folder: any, Tag = '') {
    try {
      if ((event.currentTarget.accept).includes(event.target.files[0].type.split('/')[1])) {
        const file = event.target.files[0];
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          this.UploadServices(Folder, reader.result, Tag, null, event.target.files[0].type.split('/')[1]);
          event.target.value = null;
        };
      } else {
        this.toast.show({ message: 'selected file not allow, allow file only ' + event.currentTarget.accept, type: toastTypeEnum.danger });
        event.target.value = null;
      }
    } catch (e) { }
  }

  ComboLoad(Combotype: String, clearChild = true) {
    if (Combotype == 'Site' && clearChild) {
      this.Sites = [];
      this.Designations = [];
      this.Dutys = [];
      this.Shifts = [];
      this.Detail.SiteId = null;
      this.Detail.DesignationId = null;
      this.Detail.DutyId = null;
      this.Detail.ShiftId = null;
    } else if (Combotype == 'Designation' && clearChild) {
      this.Designations = [];
      this.Dutys = [];
      this.Shifts = [];
      this.Detail.DesignationId = null;
      this.Detail.DutyId = null;
      this.Detail.ShiftId = null;
    } else if (Combotype == 'Duty' && clearChild) {
      this.Dutys = [];
      this.Shifts = [];
      this.Detail.DutyId = null;
      this.Detail.ShiftId = null;
    } else if (Combotype == 'ShiftLoadBasedOnDesignationDuty' && clearChild) {
      this.Shifts = [];
      this.Detail.ShiftId = null;
    } else if (Combotype == 'Client' && clearChild) {
      this.Detail.ClientId = null;
      this.Detail.SiteId = null;
      this.Detail.DesignationId = null;
      this.Detail.DutyId = null;
      this.Detail.ShiftId = null;

      this.Clients = [];
      this.Sites = [];
      this.Designations = [];
      this.Dutys = [];
      this.Shifts = [];
    }

    this.combo.ComboLoad({
      'Combotype': Combotype,
      'BranchId': (Combotype == 'Client' || Combotype == 'Site' || Combotype == 'Designation' || Combotype == 'Duty' || Combotype == 'ShiftLoadBasedOnDesignationDuty' || (this.Detail.EmpMasterId == 0 || (this.Detail.EmpMasterId > 0 && Combotype == 'Branch'))) ? this.Detail.BranchID : 0,
      'ClientId': (Combotype == 'Client' || Combotype == 'Site' || Combotype == 'Designation' || Combotype == 'Duty' || Combotype == 'ShiftLoadBasedOnDesignationDuty' || (this.Detail.EmpMasterId == 0 || (this.Detail.EmpMasterId > 0 && Combotype == 'Branch'))) ? this.Detail.ClientId : 0,
      'SiteId': (Combotype == 'Site' || Combotype == 'Designation' || Combotype == 'Duty' || Combotype == 'ShiftLoadBasedOnDesignationDuty' || (this.Detail.EmpMasterId == 0 || (this.Detail.EmpMasterId > 0 && Combotype == 'Site'))) ? this.Detail.SiteId : 0,
      'DesignationId': (Combotype == 'Designation' || Combotype == 'Duty' || Combotype == 'ShiftLoadBasedOnDesignationDuty' || (this.Detail.EmpMasterId == 0 || (this.Detail.EmpMasterId > 0 && Combotype == 'Designation'))) ? this.Detail.DesignationId : 0,
      'DutyId': (Combotype == 'Duty' || Combotype == 'ShiftLoadBasedOnDesignationDuty' || (this.Detail.EmpMasterId == 0 || (this.Detail.EmpMasterId > 0 && Combotype == 'Duty'))) ? this.Detail.DutyId : 0,
      'EmpType': 'Front',
    }).subscribe({
      next: (response) => {
        if (Combotype == 'Branch') {
          if (response.ComboLoad) {
            this.Branchs = response.ComboLoad;
          }
        } else if (Combotype == 'Gender') {
          if (response.ComboLoad) {
            this.Genders = response.ComboLoad;
          }
        }
        // else if (Combotype == 'ServiceType') {
        //   if (response.ComboLoad) {
        //     this.ServiceTypes = response.ComboLoad;
        //   }
        // } 
        else if (Combotype == 'Client') {
          if (response.ComboLoad) {
            this.Clients = response.ComboLoad;
          }
        } else if (Combotype == 'Site') {
          if (response.ComboLoad) {
            this.Sites = response.ComboLoad;
          }
        } else if (Combotype == 'Designation') {
          if (response.ComboLoad) {
            this.Designations = response.ComboLoad;
          }
        } else if (Combotype == 'Duty') {
          if (response.ComboLoad) {
            this.Dutys = response.ComboLoad;
          }
        } else if (Combotype == 'ShiftLoadBasedOnDesignationDuty') {
          if (response.ComboLoad) {
            this.Shifts = response.ComboLoad;
          }
        }
        this.isDisabled = false;
      },
      complete: () => {
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ESS_FillComboOAS(Type: String) {
    this.isDisabled = true;
    return this.musterAttendance.ESS_FillComboOAS({ 'SelectType': Type }).subscribe({
      next: (response) => {
        if (response.Table) {
          if (Type == "ServiceType") {
            this.ServiceTypes = response.Table;
            this.Detail.ServiceTypeId = this.ServiceTypes[0].ServiceTypeID;
          } else if (Type == "Vendor") {
            this.Vendors = response.Table;
          }
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  RemoveAttechment(id: number) {
    if (id == 1) {
      this.Detail.AadharAttachment = null;
      this.Detail.AadhaarAttachmentURL = null;
    } else if (id == 2) {
      this.Detail.Photo = null;
      this.Detail.PhotoURL = null;
    }
  }

  aadhaarKyc() {
    if (this.VerificationStatus.AADHAARCardVerificationEnabled) {
      const modalRef = this.modalService.open(AadhaarKYCComponent, { size: 'lg', backdrop: 'static', });
      modalRef.componentInstance.EmpMasterId = this.Detail.EmpMasterId;
      modalRef.componentInstance.EmpType = 'Front';
      modalRef.componentInstance.AadhaarNo = this.Detail.AadharNo;
      modalRef.result.then(result => {
        if (result != null && result != undefined) {

          //this.RegistrationDetail.Verification.AadharrequestId = result.AadharrequestId;
          this.Detail.AADHARVerificationID = result.AADHAARVerificationID;
          this.Detail.AadhaarVerificationStatus = result.AadharVerificationStatus;
          this.Detail.AadharNoKyc = result.AadharNoKyc;
          this.Detail.AadharNo = result.AadhaarNo;
          this.Detail.NameAsPerAadhar = result.NameAsPerAadhaar;
          this.Detail.AadharBirthDate = result.BirthDate;
          this.Detail.AadhaarGender = result.Gender;
          this.Detail.AadharImage = result.photo;
          this.Detail.AadharAddress1 = result.LocalAddress1;
          this.Detail.AadharAddress2 = result.LocalAddress2;



          if (this.Detail.FirstName == null || this.Detail.FirstName == '') {
            this.Detail.FirstName = this.Detail.NameAsPerAadhar;
          }


          if (this.Detail.AadharBirthDate.includes("/")) {
            if (this.Detail.BirthDateObj == null || this.Detail.BirthDateObj == '') {
              this.Detail.BirthDateObj = this.dateFormat.parse(moment(this.Detail.AadharBirthDate.split("/")[1] + '/' + this.Detail.AadharBirthDate.split("/")[0] + '/' + this.Detail.AadharBirthDate.split("/")[2]).format('DD MMM YYYY'))
            }
            this.Detail.AadharBirthDate = moment(this.Detail.AadharBirthDate.split("/")[1] + '/' + this.Detail.AadharBirthDate.split("/")[0] + '/' + this.Detail.AadharBirthDate.split("/")[2]).format('DD MMM YYYY');
          } else if (this.Detail.AadharBirthDate.includes("-")) {
            if (this.Detail.BirthDateObj == null || this.Detail.BirthDateObj == '') {
              this.Detail.BirthDateObj = this.dateFormat.parse(moment(this.Detail.AadharBirthDate.split("-")[1] + '/' + this.Detail.AadharBirthDate.split("-")[0] + '/' + this.Detail.AadharBirthDate.split("-")[2]).format('DD MMM YYYY'))
            }
            this.Detail.AadharBirthDate = moment(this.Detail.AadharBirthDate.split("-")[1] + '/' + this.Detail.AadharBirthDate.split("-")[0] + '/' + this.Detail.AadharBirthDate.split("-")[2]).format('DD MMM YYYY');
          }



          if (this.Detail.GenderId == null || this.Detail.GenderId == '' || this.Detail.GenderId == 0) {
            this.Detail.GenderId = this.Genders.filter((e: any) =>
              (this.common.ToLowerCase(e.GenderName) == 'male' && this.common.ToLowerCase(this.Detail.AadhaarGender) == 'm') ||
              (this.common.ToLowerCase(e.GenderName) == 'female' && this.common.ToLowerCase(this.Detail.AadhaarGender) == 'f') ||
              (this.common.ToLowerCase(e.GenderName) == 'other' && this.common.ToLowerCase(this.Detail.AadhaarGender) != 'm' && this.common.ToLowerCase(this.Detail.AadhaarGender) != 'f'))[0].GenderMasterID;
          }

          try {
            this.Detail.AadharGenderID = this.Genders.filter((e: any) =>
              (this.common.ToLowerCase(e.GenderName) == 'male' && this.common.ToLowerCase(this.Detail.AadhaarGender) == 'm') ||
              (this.common.ToLowerCase(e.GenderName) == 'female' && this.common.ToLowerCase(this.Detail.AadhaarGender) == 'f') ||
              (this.common.ToLowerCase(e.GenderName) == 'other' && this.common.ToLowerCase(this.Detail.AadhaarGender) != 'm' && this.common.ToLowerCase(this.Detail.AadhaarGender) != 'f'))[0].GenderMasterID;
          } catch (e) { }


          this.UploadServices(this.common.CompanyParameterValue.PhotoFolder, this.Detail.AadharImage, 'aadharphoto')
        }
      });
    } else {
      const modalRef = this.modalService.open(AlertWarningComponent, {
        size: 'md',
        backdrop: 'static',
        centered: true,
        windowClass: 'confirmation-modal'
      });
      modalRef.componentInstance.Message = "Aadhaar verification not enabled. please contact your administrator.";
      modalRef.result.then((result: any) => { });
    }

  }

  UploadServices(Folder: string, Base64: any, Tag = '', index = null, type = '') {
    this.isDisabled = true;
    this.utility.Upload({ 'DomainName': this.user.Domain, 'folder': Folder, 'CompanyCode': this.user.CompanyCode, 'FileBase64': Base64 }).subscribe((response: any) => {
      if (response.FileName != "") {
        if (Folder == this.common.CompanyParameterValue.PhotoFolder && Tag == '') {
          this.Detail.Photo = response.FileName;
          this.Detail.PhotoURL = response.Url;
        } else if (Folder == this.common.CompanyParameterValue.PhotoFolder && Tag == 'aadharphoto') {
          this.Detail.AadharImage = response.FileName;
          this.Detail.AadhaarPhotoURL = response.Url;

          if (this.Detail.Photo == null || this.Detail.Photo == '') {
            this.Detail.Photo = response.FileName;
            this.Detail.PhotoURL = response.Url;
          }
        }
        else if (Folder == this.common.CompanyParameterValue.AadhaarFolder && Tag == '') {
          this.Detail.AadharAttachment = response.FileName;
          this.Detail.AadhaarAttachmentURL = response.Url;
        }
      } else {
        this.toast.show({ message: 'Image not uploaded', type: toastTypeEnum.warning });
      }
      this.isDisabled = false;
    }, (error) => {
      this.isDisabled = false;
    });
  }

  ResetVerification(index: any) {
    const modalRef = this.modalService.open(ConfirmationComponent, {
      size: 'md',
      backdrop: 'static',
      centered: true,
      windowClass: 'confirmation-modal'
    });
    modalRef.componentInstance.Message = 'Do you want to reset?';
    modalRef.result.then((result: any) => {
      if (result) {
        if (index == 1) {
          this.Detail.AADHARVerificationID = null;
          this.Detail.AadharNo = null;
          this.Detail.AadharNoKyc = null;
          this.Detail.AadharBirthDate = null;
          this.Detail.AadhaarGender = null;
          this.Detail.AadharImage = null;
          this.Detail.AadhaarPhotoURL = null;
          this.Detail.AadharAddress1 = null;
          this.Detail.AadharAddress2 = null;
          this.Detail.AadharAttachment = null;
          this.Detail.AadhaarAttachmentURL = null;
          this.Detail.AadhaarVerificationStatus = 'Not Verified';
        }
      }
    });
  }

  async ESS_EmpSubContractor_InsertUpdate() {
    if (this.VerificationStatus.CompulsoryAADHAARKYCVerification && (this.Detail.AADHARVerificationID == null || this.Detail.AADHARVerificationID == '' || this.Detail.AADHARVerificationID == 0)) {
      this.toast.show({ message: 'Please verify aadhar card.', type: toastTypeEnum.warning });
    } else if (this.Detail.Photo == null || this.Detail.Photo == '') {
      this.toast.show({ message: 'Upload photo', type: toastTypeEnum.warning });
    } else {

      const difDay = this.getDayDifference(this.Detail.TodayDate, this.Detail.joiningDate);
      const modalRef = this.modalService.open(ConfirmationComponent, {
        size: 'md',
        backdrop: 'static',
        centered: true,
        windowClass: 'confirmation-modal'
      });
      modalRef.componentInstance.Message = difDay > 0 ? 'The employee will turn 18 on ' + this.Detail.joiningDate + '.  continue with the registration?' : 'Do you want to save?';
      modalRef.result.then((result: any) => {
        if (result) {
          this.isDisabled = true;
          this.Detail.BirthDate = this.dateFormat.format(this.Detail.BirthDateObj);

          this.employeeRegistration.ESS_EmpSubContractor_InsertUpdate(this.Detail).subscribe({
            next: async (response) => {
              if (response.Error_Code == "15") {
                const modalRef = this.modalService.open(AlertSuccessComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.Error_Message;
                modalRef.result.then((result: any) => {
                  if (result) {
                    this.close();
                  }
                });
              } else {
                const modalRef = this.modalService.open(AlertWarningComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.Error_Message;
                modalRef.result.then((result: any) => { });
              }
              this.isDisabled = false;
            },
            complete: () => { },
            error: (error) => {
              this.isDisabled = false;
            },
          });
        }
      });
    }
  }

  async ESS_EmployeeSubcontracterSelect() {
    this.isDisabled = true;
    this.employeeRegistration.ESS_EmployeeSubcontracterSelect({ 'SelectType': 'EW', EmpMasterId: this.Detail.EmpMasterId, 'SubType': 'all' }).subscribe({
      next: async (response) => {
        if (response.Table) {
          this.Detail.SelectType = 'u';
          this.Detail.EmpMasterId = response.Table[0].EmpMasterID;
          this.Detail.NameAsPerAadhar = response.Table[0].Aadhar_Name;
          this.Detail.FirstName = response.Table[0].FirstName;
          this.Detail.MiddleName = response.Table[0].MiddleName;
          this.Detail.LastName = response.Table[0].LastName;
          this.Detail.Photo = response.Table[0].Photo;
          if (this.Detail.Photo != null && this.Detail.Photo != "") {
            this.Detail.PhotoURL = this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.PhotoFolder + '/' + this.Detail.Photo;
          }
          this.Detail.GenderId = response.Table[0].GenderMasterID;
          this.Detail.BranchID = response.Table[0].BranchMasterID;
          this.Detail.BranchName = response.Table[0].BranchName;
          this.Detail.ClientId = response.Table[0].ClientGroupMasterId;
          this.Detail.ClientGroupName = response.Table[0].ClientGroupName;
          this.Detail.SiteId = response.Table[0].SiteMasterID;
          this.Detail.SiteName = response.Table[0].SiteName;
          this.Detail.SiteCode = response.Table[0].SiteCode;
          this.Detail.VendorId = response.Table[0].VendorId;
          this.Detail.VendorCode = response.Table[0].VendorCode;
          this.Detail.VendorName = response.Table[0].VendorName;
          this.Detail.DesignationId = response.Table[0].DesignationMasterID;
          this.Detail.DesignationName = response.Table[0].DesignationName;
          this.Detail.DutyId = response.Table[0].DutyMasterID;
          this.Detail.DutyName = response.Table[0].DutyName;
          this.Detail.ShiftId = response.Table[0].ShiftMasterID;
          this.Detail.ShiftCode = response.Table[0].ShiftCode;
          this.Detail.ShiftTitle = response.Table[0].ShiftTitle;
          this.Detail.BirthDate = response.Table[0].BirthDate;
          if (this.Detail.BirthDate != "" && this.Detail.BirthDate != null) {
            this.Detail.BirthDateObj = this.dateFormat.parse(this.Detail.BirthDate);
          }
          this.Detail.ServiceTypeId = response.Table[0].ServiceTypeID;
          this.Detail.ServiceType = response.Table[0].ServiceTypeName;
          this.Detail.AADHARVerificationID = response.Table[0].AadharVerificationId;
          this.Detail.AadharNo = response.Table[0].AadharNo;
          this.Detail.AadharNoKyc = response.Table[0].Aadhar_NoKYC;
          this.Detail.AadharBirthDate = response.Table[0].Aadhar_BirthDate;
          this.Detail.AadharGenderID = response.Table[0].Aadhar_GenderId;
          this.Detail.AadhaarGender = response.Table[0].Aadhar_GenderName;
          this.Detail.AadharImage = response.Table[0].Aadhar_Image;
          if (this.Detail.AadharImage != null && this.Detail.AadharImage != "") {
            this.Detail.AadhaarPhotoURL = this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.PhotoFolder + '/' + this.Detail.AadharImage;
          }
          this.Detail.AadharAddress1 = response.Table[0].Aadhar_Address1;
          this.Detail.AadharAddress2 = response.Table[0].Aadhar_Address2;
          this.Detail.AadharAttachment = response.Table[0].AadharAttachment;
          if (this.Detail.AadharAttachment != null && this.Detail.AadharAttachment != "") {
            this.Detail.AadhaarAttachmentURL = this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.AadhaarFolder + '/' + this.Detail.AadharAttachment;
          }
          this.Detail.AadhaarVerificationStatus = response.Table[0].AadharVerificationStatus;
          this.Detail.joiningDate = response.Table[0].JoiningDate;
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  SelectDate(SelectType: string): Promise<any> {
    this.isDisabled = true;
    return new Promise((resolve, reject) => {
      this.utility.SelectDate({ 'SelectType': SelectType }).subscribe({
        next: (response) => {
          if (SelectType == 'RegistrationDate') {
            this.Detail.TodayDate = response.Table[0].RegistrationDate
          } else if (SelectType == 'PreJoiningDate') {
            this.PostJoiningDate = response.Table[0].FutureJoiningDate;
          }
          this.isDisabled = false;
          resolve(true);
        },
        complete: () => { },
        error: (error) => {
          this.isDisabled = false;
          reject(error);
        },
      });
    });
  }

  getDayDifference(d1: string, d2: string): number {
    const date1 = new Date(d1);
    const date2 = new Date(d2);

    date1.setHours(0, 0, 0, 0);
    date2.setHours(0, 0, 0, 0);

    const msPerDay = 1000 * 60 * 60 * 24;
    const diff = (date2.getTime() - date1.getTime()) / msPerDay;

    return diff;
  }

  Deactive() {
    if (this.Detail.EmpMasterId > 0 && this.common.PageRight.IsEdit) {
      const modalRef = this.modalService.open(ConfirmationComponent, {
        size: 'md',
        backdrop: 'static',
        centered: true,
        windowClass: 'confirmation-modal'
      });
      modalRef.componentInstance.Message = 'Do you want to deactive employee?';
      modalRef.result.then((result: any) => {
        if (result) {
          this.isDisabled = true;
          this.employeeRegistration.ESS_EmpSubContractor_InsertUpdate({ 'SelectType': 'Deactivate', 'EmpMasterId': this.Detail.EmpMasterId, 'companyCode': this.user.CompanyCode }).subscribe({
            next: async (response) => {
              if (response.Error_Code == "781") {
                const modalRef = this.modalService.open(AlertSuccessComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.Error_Message;
                modalRef.result.then((result: any) => {
                  if (result) {
                    this.close();
                  }
                });
              } else {
                const modalRef = this.modalService.open(AlertWarningComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.Error_Message;
                modalRef.result.then((result: any) => { });
              }
              this.isDisabled = false;
            },
            complete: () => { },
            error: (error) => {
              this.isDisabled = false;
            },
          });
        }
      });
    }
  }

  GetAadharPanBankCompulsory() {
    this.isDisabled = true;
    this.employeeRegistration.GetAadharPanBankCompulsory({}).subscribe({
      next: (response) => {
        if (response) {
          this.VerificationStatus = response;
        }
        this.isDisabled = false;
      },
      complete: () => {

      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  close() {
    this.router.navigate(['/onboarding/subcontractor']);
  }
}
